import type { CatalogComponentEntry } from './component-registry.types'
import {
  AlertTriangleIcon,
  ChevronRightIcon,
  CouponIcon,
  MessageSquareIcon,
  PlayCircleIcon,
} from '@/shared/ui'

export const iconEntries: CatalogComponentEntry[] = [
  {
    name: 'Icon / Play Circle',
    path: 'shared/ui/icons/play-circle',
    layer: 'shared',
    description: 'Play circle icon for LK advertising cards.',
    component: PlayCircleIcon,
    render: () => <PlayCircleIcon />,
  },
  {
    name: 'Icon / Message Square',
    path: 'shared/ui/icons/message-square',
    layer: 'shared',
    description: 'Message square icon for LK advertising cards.',
    component: MessageSquareIcon,
    render: () => <MessageSquareIcon />,
  },
  {
    name: 'Icon / Coupon',
    path: 'shared/ui/icons/coupon',
    layer: 'shared',
    description: 'Coupon icon for partner discounts.',
    component: CouponIcon,
    render: () => <CouponIcon />,
  },
  {
    name: 'Icon / Chevron Right',
    path: 'shared/ui/icons/chevron-right',
    layer: 'shared',
    description: 'Right chevron icon for CTA affordances.',
    component: ChevronRightIcon,
    render: () => <ChevronRightIcon />,
  },
  {
    name: 'Icon / Alert Triangle',
    path: 'shared/ui/icons/alert-triangle',
    layer: 'shared',
    description: 'Alert triangle icon for warning states.',
    component: AlertTriangleIcon,
    render: () => <AlertTriangleIcon />,
  },
]
